export default __webpack_public_path__ + "static/media/clinte.e586075b.xlsx";